import * as types from './actionTypes';
import * as api from '../../../../common/api';

export const fetchProductOffers = () => ({
    types: [types.FETCH_OFFERS_REQUEST, types.FETCH_OFFERS_SUCCESS, types.FETCH_OFFERS_FAILURE],
    apiCall: () => api.fetchProductOffers()
})

export const fetchPartnerOffers = (partnerId) => ({
    types: [types.FETCH_OFFERS_REQUEST, types.FETCH_OFFERS_SUCCESS, types.FETCH_OFFERS_FAILURE],
    apiCall: () => api.fetchPartnerOffers(partnerId)
});

export const fetchProductPrices = (customerId, commercialProductsWithOffers) => ({
    types: [types.FETCH_PRICES_REQUEST, types.FETCH_PRICES_SUCCESS, types.FETCH_PRICES_FAILURE],
    apiCall: () => api.fetchProductPrices(customerId, commercialProductsWithOffers)
});

export const orderSoftware = (customerId, commercialProductsWithOffers, customerOfferId, channelIdList) => ({
    types: [types.ORDER_SOFTWARE_REQUEST, types.ORDER_SOFTWARE_SUCCESS, types.ORDER_SOFTWARE_FAILURE],
    apiCall: () => api.orderNewSoftwareProducts(customerId, commercialProductsWithOffers, customerOfferId, channelIdList)
});

export const orderHardware = (customerId, commercialProductsWithOffers, customerOfferId, skipShippingOrder) => ({
    types: [types.ORDER_HARDWARE_REQUEST, types.ORDER_HARDWARE_SUCCESS, types.ORDER_SOFTWARE_FAILURE],
    apiCall: () => api.orderNewHardwareProducts(customerId, commercialProductsWithOffers, customerOfferId, skipShippingOrder)
});

export const selectProduct = (id) => ({
    type: types.SELECT_PRODUCT,
    id
});

export const saveStart = () => ({
    type: types.SAVE_START
});

export const saveStop = () => ({
    type: types.SAVE_STOP
});

export const setSkipShippingOrder = (flag) => ({
    type: types.SET_SKIP_SHIPPING_ORDER,
    flag
});

export const setDisplayType = (displayType) => ({
    type: types.SET_DISPLAY_TYPE,
    displayType
});